<template>
  <b-overlay :show="wait">
    <b-row>
      <b-col>
        <b-input-group prepend="Envio">
          <b-input v-model="Codigo" autofocus placeholder="Numero de guia"></b-input>
          <template #append>
            <b-button-group>
              <b-button small variant="primary" @click="Buscar"><b-icon-search /> </b-button>
              <b-button small variant="primary" @click="captura = true"><b-icon-camera-fill /> </b-button>
            </b-button-group>
          </template>
        </b-input-group>
      </b-col>
    </b-row>
    <div v-if="captura" id="camara">
      <StreamBarcodeReader @decode="onDecode" @loaded="onLoaded"></StreamBarcodeReader>
    </div>

    <div v-show="hayDatos">
      <hr />
      <div v-if="!Entregado">
        <b-row>
          <b-col>
            <b-input-group class="my-2" prepend="Envia">
              <label class="form-control" v-html="NombreEnvia" />
            </b-input-group>

            <b-input-group class="my-2" prepend="Recibe">
              <label class="form-control" v-html="NombreRecibe" />
            </b-input-group>

            <b-input-group class="my-2" prepend="Piezas">
              <div class="form-control">
                <span :class="`tag text-white ${ p.Frio ? 'bg-info' : 'bg-primary'}` " v-for="(p, i) in paks" :key="i">{{ p.Tipo }} <b-icon-thermometer v-show="p.Frio"  />  </span>
              </div>
            </b-input-group>

            <b-card bg-variant="success" v-if="TieneDeuda">
              <b-input-group class="my-2" prepend="Deuda" append="$">
                <label class="form-control" v-html="deuda" />
              </b-input-group>

              <b-input-group append="$" prepend="Pago">
                <b-input v-model="Pago"></b-input>
              </b-input-group>
            </b-card>

            <b-input-group class="my-2" prepend="Entregado">
              <b-input v-model="entregado"></b-input>
            </b-input-group>
            <b-input-group class="my-2" prepend="Documento">
              <b-input v-model="documento"></b-input>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="text-center">
            <b-button :disabled="!PuedoEntregar" @click="Guardar" class="my-2 " variant="success">Entregar</b-button>
          </b-col>
        </b-row>
      </div>
      <div v-else>
        <b-card title="Entregado">
          <b-input-group class="my-2" prepend="Nombre:">
            <label class="form-control" v-html="envio.Receptor.Receptor" />
          </b-input-group>

          <b-input-group class="my-2" prepend="Documento:">
            <label class="form-control" v-html="envio.Receptor.Doc" />
          </b-input-group>
        </b-card>
      </div>
    </div>
  </b-overlay>
</template>
<script>
import firebase from "firebase/app";
import "firebase/firestore";

if (!firebase.apps.length) firebase.initializeApp({ projectId: "diazvelizexpress" });
else firebase.app();

const db = firebase.firestore();
import { StreamBarcodeReader } from "vue-barcode-reader";

let MisDatos = { Pago: null, captura: false, Codigo: null, Envio: {}, envia: {}, recibe: {}, wait: false, contenido: [], entregado: null, documento: null };

export default {
  beforeCreate() {
    MisDatos.captura = false;
  },
  computed: {
    Entregado() {
      let rs = this.Envio && this.Envio.length ? this.Envio[0].Entregado : false;

      return rs;
    },
    deuda() {
      let d = this.recibe?.Deuda || 0;

      return d;
    },
    TieneDeuda() {
      let hayDeuda = !!this.recibe?.Deuda;

      return hayDeuda;
    },
    PuedoEntregar() {
      if (this.recibe) {
        let hayDeuda = !!this.recibe.Deuda;
        let receptor = !!this.entregado && !!this.documento;

        if (receptor) {
          if (hayDeuda) {
            return !!this.Pago;
          } else return true;
        }

        return false;
      } else return false;
    },
    granTotal() {
      if (this.envio) {
        let gt = this.envio.GranTotal;
        return gt;
      } else return 0;
    },
    paks() {
      let p = this.contenido.map((p) => {
        return {Tipo: p.Tipo, Frio:p.Frio || false };
      });

      return p;
    },

    hayDatos() {
      let n = this.NombreEnvia;

      return n;
    },
    NombreEnvia() {
      let dato = this.envia?.Nombre || "";
      return dato;
    },
    NombreRecibe() {
      let dato = this.recibe?.Nombre || "";
      return dato;
    },
    envio() {
      if (this.Envio) return this.Envio[0];
      else return {};
    },
  },
  watch: {
    Envio(v) {
      if (v) {
        let info = v.length ? v[0] : v;
        if (info?.Envia) {
          this.$bind("envia", db.collection("Cliente").doc(info.Envia));
          this.$bind("recibe", db.collection("Cliente").doc(info.Recibe)).then((d) => {
            MisDatos.entregado = d.Nombre;
          });
          this.contenido = info.Contenido;
        }
      } else {
        this.envia = {};
        this.recibe = {};
      }
    },
  },
  mounted() {
    let id = localStorage.IdEnvio || null;

    if (id) {
      this.setEnvio(id, false);
      localStorage.removeItem("IdEnvio");
    }
  },
  data() {
    return MisDatos;
  },
  components: { StreamBarcodeReader },
  methods: {
    limpiar() {
      MisDatos.Codigo = "";
      MisDatos.Contenido = [];
      MisDatos.entregado = null;
      MisDatos.documento = null;
      MisDatos.envia = {};
      MisDatos.recibe = {};
    },
    Guardar() {
      let self = this;
      let tmpID = this.envio?.id || this.Codigo;
      MisDatos.wait = true;

      let guardar = function() {
        let entrega = { Receptor: self.entregado, Doc: self.documento  ,fecha: new Date()};
        let id = tmpID;

        db.collection("Envios")
          .doc(id)
          .update({
            Receptor: entrega,
            Entregado: true,
          })
          .then(() => {
            MisDatos.wait = false;
            self.limpiar();
          });
      };

      let hayDeuda = !!this.recibe.Deuda;

      if (hayDeuda) {
        let cliente = this.recibe.id;
        let saldo = this.recibe.Deuda - this.Pago;

        db.collection("Cliente")
          .doc(cliente)
          .update({ Deuda: saldo })
          .then(() => {
            guardar();
          });
      } else {
        guardar();
      }
    },
    Buscar() {
      this.setEnvio(this.Codigo);
    },
    setEnvio(v, guia = true) {
      this.wait = true;

      if (guia) {
        this.$bind("Envio", db.collection("Envios").where("NoGuia", "==", v)).then(() => {
          this.wait = false;
        });
      } else {
        this.$bind("Envio", db.collection("Envios").doc(v)).then(() => {
          this.wait = false;
        });
      }
    },
    onLoaded() {},
    onDecode(v) {
      let porId = isNaN(v);

      if (porId) {
        let info = v.split("/");
        this.Codigo = info[4];
        this.setEnvio(info[4]);
      } else {
        this.Codigo = v;
        this.setEnvio(v);
      }

      this.captura = false;
    },
  },
};
</script>

<style>
#camara {
  width: 375px;
}
.input-group-text {
  width: 100px;
}
.tag {
  border: 1px solid #666;
  border-radius: 10px;
  padding: 3px 10px;
  margin-right: 5px;
}
</style>
